import React from 'react'
import { DOC_WMS_ORDER_ERROR_CSV_FILES } from 'constants/path'
import { SectionGrant } from 'components/functional'
import { canShowSidebar } from 'policies/DOCWmsOrderCsvFilePolicy'
import MenuItem from '../MenuItem'
import { useQuery } from '../useQuery'

type Props = ReturnType<typeof useQuery>

export const DOCWmsOrderErrorCsvFileMenuItem: React.FC<Props> = ({ viewer }) => {
  return (
    <SectionGrant authorized={canShowSidebar(viewer)}>
      <MenuItem href={DOC_WMS_ORDER_ERROR_CSV_FILES}>CSV取込エラー</MenuItem>
    </SectionGrant>
  )
}
